(function () {
  'use strict';

  function initialiseAccordions() {
    document.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle, index) {
      var item = toggle.closest('.acci');
      var panel = item ? item.querySelector('.accc') : null;
      if (!item || !panel) return;

      var suffix = String(index + 1);
      var panelId = panel.id || 'MvcAccordionPanel-' + suffix;
      var toggleId = toggle.id || 'MvcAccordionToggle-' + suffix;

      panel.id = panelId;
      toggle.id = toggleId;
      toggle.setAttribute('aria-controls', panelId);
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', toggleId);

      function syncState() {
        toggle.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      }

      syncState();
      toggle.addEventListener('click', function () {
        window.requestAnimationFrame(syncState);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAccordions);
  } else {
    initialiseAccordions();
  }
})();
